export { default } from "./Illustration";
